import { API_PATH } from "@/common/constant";
import ApiService from "@/common/api.service";

export const GET_SETTING_CAN_VIEW_PEERS_API = (params) =>
  ApiService.query(API_PATH.SETTING_CAN_VIEW_PEERS, { ...params });

export const UPDATE_SETTING_CAN_VIEW_PEERS = (params) =>
  ApiService.put(API_PATH.SETTING_CAN_VIEW_PEERS, { ...params });
